import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './BGMManager.css';

const BGMManager = () => {
  const audioRef = useRef(null);
  const location = useLocation();
  const [showMuteButton, setShowMuteButton] = useState(true);


  const [volume, setVolume] = useState(() => {
    return parseFloat(localStorage.getItem('bgmVolume')) || 0.5;
  });

  const [muted, setMuted] = useState(() => {
    return localStorage.getItem('bgmMuted') === 'true';
  });
  useEffect(() => {
    window.setShowGlobalMuteButton = setShowMuteButton;
  }, []);

  // ✅ Update audio source based on route
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    let src = '/bgm-default.bgmdata';

    if (
      location.pathname === '/deckbuilder' ||
      location.pathname === '/tool/time-limit' ||
      location.pathname === '/duel'
    ) {
      src = '/bgm-duel.bgmdata';
    } else if (location.pathname === '/tools/card-search') {
      src = '/bgm-cardsearch.bgmdata';
    } else if (
      ['/shop', '/history', '/shop/ocg', '/shop/tcg', '/shop/misc', '/shop/accessories'].includes(location.pathname)
    ) {
      src = '/bgm-shop.bgmdata';
    }


    if (!audio.src.includes(src)) {
      audio.src = src;
      audio.load();
    }

    // ✅ Auto play if unmuted
    if (!muted) {
      audio.volume = volume;
      audio
        .play()
        .then(() => {
          // success
        })
        .catch(() => {
          // will retry on interaction
        });
    }
  }, [location.pathname, muted, volume]);



  // ✅ Expose global setter for settings modal
  useEffect(() => {
    window.setBGMVolume = (v) => {
      const clamped = Math.min(1, Math.max(0, v));
      setVolume(clamped);
      localStorage.setItem('bgmVolume', clamped);
      if (audioRef.current) {
        audioRef.current.volume = muted ? 0 : clamped;
      }
    };
  }, [muted]);

  // ✅ Retry auto-play after reload or refresh
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const tryPlay = () => {
      audio.volume = muted ? 0 : volume;
      if (audio.paused && !muted) {
        audio.play().catch(() => {
          // Autoplay blocked — try again on first user click
          document.addEventListener('click', tryPlay, { once: true });
        });
      }
    };

    tryPlay();
  }, [muted, volume]);

  // ✅ Pause when tab is inactive; resume when active
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleVisibility = () => {
      if (document.hidden) {
        audio.pause(); // 🔇 tab hidden
      } else {
        if (!muted) {
          audio.play().catch(() => { }); // 🔊 tab visible and unmuted
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [muted]);

  const toggleMute = () => {
    const newMuted = !muted;
    setMuted(newMuted);
    localStorage.setItem('bgmMuted', newMuted);

    const audio = audioRef.current;
    if (audio) {
      audio.volume = newMuted ? 0 : volume;
      if (!newMuted && audio.paused && !document.hidden) {
        audio.play().catch(() => { });
      } else if (newMuted) {
        audio.pause();
      }
    }
  };

  useEffect(() => {
    window.toggleBGMMute = toggleMute;
  }, [toggleMute]);

  useEffect(() => {
    window.getBGMMuted = () => muted;
  }, [muted]);


  return (
    <>
      <audio ref={audioRef} loop autoPlay hidden />
      {/* {location.pathname !== '/duel' && showMuteButton && (
        <button className="mute-toggle" onClick={toggleMute}>
          {muted ? '🔇' : '🔊'}
        </button>
      )} */}

    </>
  );
};

export default BGMManager;
